import { render, staticRenderFns } from "./LeaveHistory.vue?vue&type=template&id=338600ec&"
import script from "./LeaveHistory.vue?vue&type=script&lang=ts&"
export * from "./LeaveHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LeaveHistory.vue"
export default component.exports